/**
    红包
**/
<template>
  <div style="width: 1200px;
    margin: 30px auto;">
        <div class="orderSuccess">
            <el-row>
                <el-col :span="3"><i class="el-icon-check orderSuccess_icon"></i></el-col>
                <el-col :span="21" >                        
                        <el-row>
                            <el-col :span="24" class="orderSuccess_tip">
                                <span class="orderSuccess_text">{{statusType(status)}}</span>
                            </el-col>
                        </el-row>        
                </el-col>               
            </el-row>
        </div>
  </div>
</template>
<script>
import { payStatus  } from '@/api/xunyou'
export default {
  data() {
    return {
        status:'',
        // orderGoodsInfo:JSON.parse(sessionStorage.getItem("orderGoodsInfo")) || [], 
        // account:JSON.parse(sessionStorage.getItem("account")) ||'',   
        // payPage:'',
        // checked:true,
        // dialogVisible:false,
        // dialogVisibles:false,
        // ruleForm:{
        //     pass:'',
        //     radio:'1'
        // },
        // rules:{
        //     pass: [
        //     { validator: validatePass, trigger: 'blur' }
        //   ],
        // }
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
    //   console.log(this.orderGoodsInfo,'带过来的订单数据')
    //   this.searchRedEnvelope()
    this.getPayStatus()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //   状态转换
    statusType(){
       switch(status) {
            case 'WAIT_BUYER_PAY':
                return '交易创建，等待买家付款'
                break;
            case 'TRADE_CLOSED':
                 return '未付款交易超时关闭，或支付完成后全额退款'
                break;
            case 'TRADE_SUCCESS':
                 return '交易支付成功'
                break;
            case 'TRADE_FINISHED':
                 return '交易结束，不可退款'
                break;
            default:                
                return '--'
        } 
    },
    // 交易状态：WAIT_BUYER_PAY（交易创建，等待买家付款）、TRADE_CLOSED（未付款交易超时关闭，或支付完成后全额退款）、TRADE_SUCCESS（交易支付成功）、TRADE_FINISHED（交易结束，不可退款）

    // // 查询状态
      getPayStatus() {
          this.loading = true
         payStatus({
             out_trade_no: this.$route.query.orderNumber  
         })
            .then(res => {
                console.log('res',res)
                this.status=res.alipay_trade_query_response.trade_status
                // this.statusType(res.alipay_trade_query_response.trade_status)
            })
            .catch(err => {
                
            })
    },

  },
};
</script>

<style scoped lang="less">
.orderSuccess{
    margin: 20px 0;
    background: white;
    padding: 30px 70px;
    font-size: 14px;
    .orderSuccess_icon{
        width: 80px;
        height: 80px;
        line-height: 80px;
        font-size: 40px;
        color: #83c44e;
        text-align: center;
        border: 2px solid #83c44e;
        border-radius: 42px;
    }
    .orderSuccess_tip{
     display: flex;
     justify-content: space-between;
     font-size: 14px;
     color: #757575;
         .orderSuccess_text{
            margin-bottom: 10px;
            font-size: 24px;
            font-weight: 400;
        }
        .orderSuccess_price{
            font-size: 24px;
            color: #78b942;
        }
     }
     .address_info{
         margin: 20px 0;
     }
     /deep/.el-collapse{
         border-bottom:0px !important;
     }
     /deep/.el-collapse-item__header {
        font-size: 14px;
        
    }
    span.text_width {
        width: 10%;
        display: inline-block;
    }
    .text_bgcolor{
        display: inline-block;
        width: 80%;
        background: #f5f5f5;
    }
    .order_detail{
        display: inline-block;
        position: absolute;
        right: 30px;
    }
    .payMethods{
        font-size: 18px;
        .payMethods_title{
            margin: 20px 0;
            padding-bottom: 20px;
            border-bottom: 1px solid #ccc;
        }
        .checked_free{
            padding: 10px;
            color: #666;
            font-size: 14px;
            border: 1px solid #e7e7e7;
            margin: 20px 0;
        }
        .payMethods_img {
            // margin: 20px;
            border: 1px solid #ccc;
        }
    }
            button.el-button.buttonBgd.el-button--primary {
               background-color: #78b942;
               border-color: #78b942;
               font-size: 18px;
               margin: 20px 0;
           }
           .textCenter {
                text-align: center;
                font-size: 25px;
            }
}
 
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/paySuccess.vue